// Automations and reminders (R10-Q16).
export const auto = {
  // the page: header, toolbar, list
  automations: "Automations",
  automation: "Automation",
  newAutomation: "New automation",
  newShort: "New",
  newRest: " automation",
  orAskInChat: "Or just ask Vantage in chat",
  searchPlaceholder: "Search automations…",
  searchLabel: "Search automations",
  kind: "Kind",
  postsTo: "Posts to",
  postsToChannel: "Posts to {channel}",
  theChannel: "the channel",
  belongsTo: "Belongs to",
  timed: "Timed",
  triggered: "Triggered",
  reminders: "Reminders",
  company: "Company",
  aTeam: "A team",
  mine: "Mine",
  listDidntLoad: "The automations didn't load",
  noneTitle: "No automations yet",
  noneBody:
    "An automation posts a report on a schedule, or tells you when something happens in Redmine or GitHub.",
  noneAsk: "or ask Vantage: “every Monday 9:00, post last week's progress here”",
  nothingMatches: "Nothing matches",
  showAll: "Show all automations",
  when: "When",
  status: "Status",
  lastRun: "Last run",
  next: "Next",
  nextWhen: "Next {when}",
  openDetails: "{name}, open details",
  count_one: "{n} automation",
  count_other: "{n} automations",
  headerLine: "{count} · {active} active · {spent} of the {cap} monthly cap used",
  // status and why it stopped
  statusActive: "Active",
  statusPaused: "Paused",
  statusNeedsAttention: "Needs attention",
  statusOnHold: "On hold",
  reasonOwnerLeft: "Paused: its owner left the team it posts to",
  reasonOwnerDeactivated: "Paused: its owner's account was turned off",
  reasonTeamArchived: "Paused: its team was archived",
  reasonFailures: "Paused after 3 failed runs: {why}",
  pausedAfterFailures: "Paused after 3 failed runs",
  myInbox: "My inbox",
  myEmail: "My email",
  todayAt: "Today {time}",
  // schedules
  presetDaily: "Daily",
  presetWeekdays: "Weekdays",
  presetWeekly: "Weekly",
  presetHourly: "Hourly",
  presetCustom: "Custom (cron)",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  // events
  evIssueCreated: "A ticket is created",
  evStatusChanged: "A ticket moves to a status",
  evAssigned: "A ticket is assigned",
  evPrOpened: "A PR is opened",
  evPrMerged: "A PR is merged",
  evReviewRequested: "A review is requested",
  evCiFailed: "CI fails",
  // the detail's lines
  createdByChat: "created by {name} in chat",
  createdByForm: "created by {name} with the form",
  createdChat: "created in chat",
  createdForm: "created with the form",
  noRunsYet: "No runs yet",
  failedRunsLine: "{n} failed · last {time} · nothing spent",
  underCentPerRun: "Under 1¢ a run",
  aboutPerRun: "About {cost} a run",
  spentSoFar: "{cost} so far",
  nothingSoFar: "nothing so far",
  seconds: "{n} s",
  minutes: "{n} min",
  pathRecipe: "from the recipe",
  pathFull: "full run",
  pathFallback: "full run, the recipe failed",
  skipSpendCap: "skipped: on hold for the spend cap",
  skipAutomationsOff: "skipped: automations were switched off",
  skipPaused: "skipped: it was paused",
  skipNeedsAttention: "skipped: it needed attention",
  skipDeleted: "skipped: it was deleted",
  skipped: "skipped",
  skippedWhy: "skipped: {why}",
  running: "running…",
  waitingToRun: "waiting to run",
  underCent: "under 1¢",
  runByHand: "run by hand",
  failed: "failed",
  failedWhy: "failed: {why}",
  guardRails:
    "At most once an hour · at most 10 active per team · stops at 90% of the spend cap · pauses after 3 failed runs",
  editorsTeam: "{team}'s members or an admin",
  editorsAdmin: "an admin",
  ownerMe: "Me",
  ownerTheTeam: "The team",
  // the chat card
  theAutomation: "the automation",
  thisAutomation: "this automation",
  cardGone: "This automation was deleted, or isn't one you can see.",
  activeNext: "Active · next {when}",
  cardSub: "{when} · posts to {dest} · {runsWith}",
  view: "View",
  pause: "Pause",
  resume: "Resume",
  pausedName: "Paused “{name}”.",
  onAgain: "“{name}” is on again.",
  // Delete, View post
  deleteTitle: "Delete “{name}”?",
  deleteBody: "It stops for good and its runs end here.",
  deleteBodyChannel: "It stops for good and its runs end here. {channel} hears that it went.",
  deletedName: "Deleted “{name}”.",
  viewPost: "View post",
  // the panel
  backToList: "Back to the list",
  details: "Automation details",
  notHere: "This automation isn't here",
  notHereBody: "It may have been deleted, or it isn't one you can see.",
  didntLoad: "It didn't load",
  fixCause: "{reason}. Fix the cause, then switch it back on.",
  onHoldNote:
    "On hold: spend is at 90% of a cap, so automations wait until it drops or an admin raises the cap. Chat keeps working.",
  renamed: "Renamed.",
  scheduleSaved: "New schedule saved.",
  destSaved: "It posts there from its next run, with a new recipe.",
  rename: "Rename",
  changeSchedule: "Change schedule",
  changeDestination: "Change destination",
  name: "Name",
  whenCron: "When (cron)",
  /** A schedule's zone when it names none: the company's (R10-B13). */
  cronHelpEdit: "Five cron fields, in its own time zone ({tz}), as when it was made.",
  savedSchedule: "Saved. Its next run makes a new recipe.",
  savedEvent: "Saved. The next event is written up the new way.",
  repinning: "Re-pinning: a sample run posts now and becomes the new recipe.",
  runningNow: "Running now. It posts to {dest} in a moment.",
  whatItDoes: "What it does",
  instruction: "Instruction",
  instructionHelp: "Plain words. Vantage turns them into the recipe below.",
  whenAndWhere: "When and where",
  runsWith: "Runs with",
  cost: "Cost",
  recipe: "Recipe",
  noRecipeForEvents:
    "Each event is written up as it happens, from the event's own facts: there's no recipe to pin.",
  recipeStale:
    "The recipe stopped working; the last runs ran in full. Re-pin to make it cheap again.",
  pinnedOn: "Pinned after the sample run on {date}, so every run is fast and looks the same.",
  pinned: "Pinned, so every run is fast and looks the same.",
  noRecipe: "No recipe yet: the next run is a full run, and its plan becomes the recipe.",
  repin: "Re-pin",
  learned: "Learned from feedback",
  learnedNone: "Nothing yet. A 👎 with a note on one of its posts teaches it for the next run.",
  lessonUndone: "Undone. Its next run won't use that lesson.",
  recentRuns: "Recent runs",
  noRunsYetPeriod: "No runs yet.",
  sampleRun: "Sample run, {date}",
  guardRailsTitle: "Guard rails",
  runNow: "Run now",
  viewOnly: "You can see this automation; only {who} can change it.",
  // the New form
  sayWhichProject: "Say which project to watch.",
  sayWhichRepo: "Say which repository to watch.",
  fillTheForm: "Give it a name, what it does and when it runs.",
  setUpSample: "Set up “{name}”. A sample run posts now.",
  setUpEvent: "Set up “{name}”. It checks every 5 minutes.",
  namePlaceholder: "Monday HoaVN progress",
  whatPlaceholder:
    "Post last week's HoaVN progress: tickets opened, moved and closed, merged PRs, and any reopened bugs.",
  whatHelpNew: "Plain words. Vantage turns them into a recipe after the sample run.",
  runs: "Runs",
  onSchedule: "On a schedule",
  onEvent: "When something happens",
  repeats: "Repeats",
  day: "Day",
  minute: "Minute",
  at: "At",
  cronHelpNew: "Company time ({tz}). Pick above, or type five cron fields. At most once an hour.",
  source: "Source",
  whatHappens: "What happens",
  project: "Project",
  repository: "Repository",
  toStatus: "To status",
  toStatusHelp: "Leave it empty for any status change.",
  assignedTo: "Assigned to",
  anyone: "Anyone",
  reviewer: "Reviewer",
  eventHelp: "Checks every 5 minutes. Only changes after it's set up count.",
  where: "Where",
  emailMe: "Email me",
  channels: "Channels",
  readsOnly: "It reads only what both its owner and the place it posts to may see.",
  creating: "Creating…",
  create: "Create",
  samplePostsNow: "A sample posts right away.",
  // reminders
  remindersDidntLoad: "Your reminders didn't load",
  noReminders: "No reminders to come",
  noRemindersBody: "Ask Vantage in chat: “remind me Friday at 4 to review the release notes”.",
  yourReminders: "Your reminders",
  reminderCancelled: "Reminder cancelled: {text}",
  couldntCancel: "Couldn't cancel it.",
  movedTo: "Moved to {when}.",
  newTime: "New time",
  keepTime: "Keep current time",
  changeTime: "Change time",
  cancelReminder: "Cancel reminder",
};
